<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Paquetes</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              small dark color="green"
              @click="exportExcel(paquetes, 'paquetes_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
            <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="dialog = true"
              small
              tile
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="paquetes"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  dense
                >
                  <!-- Valores que ocupan botons, chips, iconos, etc -->
                  <template v-slot:item.deleted="{ item }">
                    <v-chip
                      v-if="item.deleted == 0"
                      small
                      color="green"
                      dark
                    >Activo</v-chip>
                    <v-chip
                      v-else
                      small
                      color="error"
                      dark
                    >Inactivo</v-chip>
                  </template>
                  <template v-slot:item.foto="{ item }">
                    <v-img :src="url + item.foto" aspect-ratio="2" contain/>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      color="grey"
                      x-small
                      @click="editItem(item)"
                      class="mr-2"
                      icon
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      color="info"
                      x-small
                      @click="viewDetalles(item)"
                      class="mr-2"
                      icon
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      color="error"
                      x-small
                      @click="deleteItem(item)"
                      class="mr-2"
                      icon
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar paquete -->
    <v-dialog
      v-model="dialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1" v-if="editedIndex > -1">
            <strong>ID: {{ editedItem.idpaquetes }}</strong>
          </span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="* Nombre del paquete"
                filled
                hide-details
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.precio"
                label="Precio"
                filled
                hide-details
                dense
                type="number"
                :hint="precioCalculado ? `Precio calculado: $${precioCalculado}` : ''"
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editedItem.notas"
                label="Notas"
                filled
                hide-details
                auto-grow
                :rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12" v-if="editedIndex > -1">
              <label>Foto actual</label>
              <v-row v-if="editedItem.foto">
                <v-col cols="12" md="6">
                  <v-card class="py-4 shadowCard">
                    <v-img :src="url + editedItem.foto" contain aspect-ratio="2"></v-img>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-file-input
                filled
                v-model="files"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="Selecciona tus imagenes" 
                prepend-icon="mdi-camera" 
                label="Foto del paquete" 
                @change="cargarFotos()"
              ></v-file-input>
              <v-row v-if="vistaPrevias.length">
                <v-col cols="12" md="6" v-for="(img, i) in vistaPrevias" :key="i">
                  <v-card class="py-4 shadowCard">
                    <v-img :src="img.url" contain aspect-ratio="2"></v-img>
                    <v-btn color="error" small @click="eliminarFoto(img.url)" top right absolute fab>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            class=""
            tile
            dark
            small
            @click="save"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para ver y gestionar detalles del paquete -->
    <v-dialog
      v-model="dialogDetalles"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Detalles del paquete: {{ paqueteActual ? paqueteActual.nombre : '' }}</span>
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            dark
            small
            @click="showDialogAgregarArticulo = true"
            tile
          >
            <v-icon left small>mdi-plus</v-icon>
            Agregar artículo
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersDetalles"
            :items="detallesPaquete"
            class="elevation-0"
            :no-data-text="'No hay artículos agregados a este paquete'"
            dense
          >
            <template v-slot:item.foto_articulo="{ item }">
              <v-img :src="url + item.foto_articulo" height="50" width="50" contain></v-img>
            </template>
            <template v-slot:item.precio_total="{ item }">
              ${{ (item.precio_articulo * item.cantidad).toFixed(2) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                color="primary"
                x-small
                @click="editDetalle(item)"
                class="mr-2"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                color="error"
                x-small
                @click="deleteDetalle(item)"
                class="mr-2"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <v-divider class="my-4"></v-divider>
          <v-row justify="end">
            <v-col cols="12" md="4">
              <v-card outlined>
                <v-card-text class="text-right">
                  <div class="text-subtitle-2">Total del paquete:</div>
                  <div class="text-h6">${{ calcularTotalPaquete().toFixed(2) }}</div>
                  <v-btn
                    color="primary"
                    small
                    icon
                    @click="actualizarPrecioPaquete"
                    class="mt-2"
                    :disabled="!detallesPaquete.length"
                    title="Actualizar precio del paquete"
                  >
                    <v-icon small>mdi-calculator</v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="closeDetalles"
          >
            <v-icon small left>mdi-arrow-left</v-icon>
            Volver
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para agregar artículo al paquete -->
    <v-dialog
      v-model="showDialogAgregarArticulo"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Agregar artículo al paquete</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedArticulo"
                :items="articulos"
                item-text="articulo"
                item-value="idarticulos"
                label="Seleccionar artículo"
                return-object
                filled
                dense
              >
                <template v-slot:selection="{ item }">
                  <v-list-item-avatar>
                    <v-img :src="url + item.foto" contain></v-img>
                  </v-list-item-avatar>
                  {{ item.articulo }} - ${{ item.precio }}
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item-avatar>
                    <v-img :src="url + item.foto" contain></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.articulo }}</v-list-item-title>
                    <v-list-item-subtitle>${{ item.precio }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="cantidadArticulo"
                label="Cantidad"
                type="number"
                min="1"
                filled
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="selectedArticulo">
              <v-card outlined>
                <v-card-text>
                  <div class="d-flex">
                    <v-img :src="url + selectedArticulo.foto" max-width="100" contain class="mr-4"></v-img>
                    <div>
                      <div class="text-h6">{{ selectedArticulo.articulo }}</div>
                      <div class="text-body-2">Precio unitario: ${{ selectedArticulo.precio }}</div>
                      <div class="text-body-1 font-weight-bold mt-2" v-if="cantidadArticulo > 0">
                        Total: ${{ (selectedArticulo.precio * cantidadArticulo).toFixed(2) }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="closeDialogAgregarArticulo"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            tile
            dark
            small
            @click="agregarArticuloAlPaquete"
            :disabled="!selectedArticulo || cantidadArticulo <= 0"
          >
            <v-icon small left>mdi-plus</v-icon>
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para editar cantidad de artículo -->
    <v-dialog
      v-model="dialogEditarDetalle"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Editar cantidad</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="d-flex align-center mb-4">
                <v-img :src="url + editedDetalle.foto_articulo" max-width="60" contain class="mr-4"></v-img>
                <div class="text-subtitle-1">{{ editedDetalle.articulo }}</div>
              </div>
              <v-text-field
                v-model="editedDetalle.cantidad"
                label="Cantidad"
                type="number"
                min="1"
                filled
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="black"
            tile
            dark
            small
            @click="closeEditarDetalle"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            tile
            dark
            small
            @click="guardarCambiosDetalle"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar este paquete?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación -->
                    <v-btn color="error" text class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C" dark class="elevation-6" @click="deleteItemConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar detalle -->
    <v-dialog v-model="dialogDeleteDetalle" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="6">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  <strong>Eliminar</strong> ¿Estás seguro que deseas eliminar este artículo del paquete?
                  <v-card-actions class="pt-6">
                    <!-- Cerrar dialogo de confirmación -->
                    <v-btn color="error" text class="mr-2" @click="closeDeleteDetalle()">No, cancelar</v-btn>
                    <!-- Guardar la información  -->
                    <v-btn color="#5C5C5C" dark class="elevation-6" @click="deleteDetalleConfirm()">Si</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>
  </v-container>
</template>
<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex';
  // Componentes
  import Alerta from '@/components/alertas/Alerta.vue';
  import carga from '@/components/alertas/carga.vue';
  import validarErrores from '@/mixins/validarErrores';
  import funcionesExcel from '@/mixins/funcionesExcel';

  export default {
    mixins: [validarErrores, funcionesExcel],
    components: {
      Alerta,
      carga,
    },
    data: () => ({
      // Alertas
      parametros: {
        dialogError: false,
        mensaje: '',
        color: ''
      },
      respuestaAlerta: false,
      loader: true,
      cargar: false,
      // Diálogos
      dialog: false,
      dialogDelete: false,
      dialogDetalles: false,
      showDialogAgregarArticulo: false,
      dialogEditarDetalle: false,
      dialogDeleteDetalle: false,
      // Índices y elementos editados
      editedIndex: -1,
      editedItem: {
        idpaquetes: 0,
        nombre: '',
        precio: 0,
        foto: '',
        notas: '',
        deleted: 0,
        fecha_creacion: null
      },
      defaultItem: {
        idpaquetes: 0,
        nombre: '',
        precio: 0,
        foto: '',
        notas: '',
        deleted: 0,
        fecha_creacion: null
      },
      // Artículos y paquetes
      paqueteActual: null,
      selectedArticulo: null,
      cantidadArticulo: 1,
      detallesPaquete: [],
      editedDetalle: {
        idpaquetes_detalles: 0,
        idpaquetes: 0,
        idarticulos: 0,
        cantidad: 1,
        articulo: '',
        precio_articulo: 0,
        foto_articulo: ''
      },
      selectedDetalleToDelete: null,
      // Precio calculado (solo para mostrar)
      precioCalculado: null,
      // URL base para imágenes
      url: '',
      // Filtros para tabla
      search: '',
      // Datos principales
      paquetes: [],
      articulos: [],
      headers: [
        { text: 'ID', value: 'idpaquetes' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Precio', value: 'precio' },
        { text: 'Foto', value: 'foto' },
        { text: 'Notas', value: 'notas' },
        { text: 'Estado', value: 'deleted' },
        { text: 'Fecha de alta', value: 'fecha_creacion' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      headersDetalles: [
        { text: 'Artículo', value: 'articulo' },
        { text: 'Imagen', value: 'foto_articulo' },
        { text: 'Precio unitario', value: 'precio_articulo' },
        { text: 'Cantidad', value: 'cantidad' },
        { text: 'Precio total', value: 'precio_total', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      // Manejo de archivos
      files: null,
      vistaPrevias: []
    }),
    computed: {
      ...mapGetters('login', ['getdatosUsuario']),
      formTitle() {
        return this.editedIndex === -1 ? 'Agregar Paquete' : 'Editar Paquete';
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      dialogDetalles(val) {
        if (!val) {
          this.detallesPaquete = [];
          this.paqueteActual = null;
        }
      },
      dialogEditarDetalle(val) {
        val || this.closeEditarDetalle();
      },
      dialogDeleteDetalle(val) {
        val || this.closeDeleteDetalle();
      }
    },
    async created() {
      this.url = this.$http.options.root + 'articulos-enlace/';
      await this.initialize();
      await this.loadArticulos();
    },
    methods: {
      // Inicializar datos
      initialize() {
        this.cargar = true;
        this.paquetes = [];
        return this.$http.get('paquetes.list').then(response => {
          this.paquetes = response.data;
          this.cargar = false;
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Cargar artículos para el selector
      loadArticulos() {
        this.cargar = true;
        return this.$http.get('articulos.list').then(response => {
          this.articulos = response.data;
          this.cargar = false;
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Editar un paquete
      editItem(item) {
        this.editedIndex = this.paquetes.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      // Ver detalles de un paquete
      viewDetalles(item) {
        this.cargar = true;
        this.paqueteActual = Object.assign({}, item);
        this.$http.get(`paquetes.detalle/${item.idpaquetes}`).then(response => {
          this.detallesPaquete = response.data.detalles || [];
          this.dialogDetalles = true;
          this.cargar = false;
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Eliminar un paquete
      deleteItem(item) {
        this.editedIndex = this.paquetes.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialogDelete = true;
      },

      // Confirmar eliminación de paquete
      deleteItemConfirm() {
        this.cargar = true;
        // Marcar como eliminado
        this.editedItem.deleted = 1;
        this.$http.put(`paquetes.update/${this.editedItem.idpaquetes}`, this.editedItem).then(response => {
          this.validarSuccess(response.data.message);
          this.initialize();
          this.closeDelete();
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Cerrar diálogo de paquete
      close() {
        this.dialog = false;
        this.vistaPrevias = [];
        this.files = null;
        this.precioCalculado = null;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      // Cerrar diálogo de eliminación
      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      // Cerrar diálogo de detalles
      closeDetalles() {
        this.dialogDetalles = false;
        this.initialize();
      },

      // Cerrar diálogo de agregar artículo
      closeDialogAgregarArticulo() {
        this.showDialogAgregarArticulo = false;
        this.selectedArticulo = null;
        this.cantidadArticulo = 1;
      },

      // Guardar un paquete
      save() {
        // Creamos el documento
        let formData = new FormData();
        // Agregamos el documento
        formData.append("file", this.files);
        formData.append("nombre", this.editedItem.nombre);
        formData.append("precio", this.editedItem.precio);
        formData.append("notas", this.editedItem.notas);
        formData.append("deleted", this.editedItem.deleted);
        formData.append("foto", this.editedItem.foto);

        this.cargar = true;
        if (this.editedIndex > -1) {
          // Actualizar paquete existente
          this.$http.put(`paquetes.update/${this.editedItem.idpaquetes}`, formData).then(response => {
            this.validarSuccess(response.data.message);
            this.initialize();
            this.close();
          }).catch(error => {
            this.validarError(error);
          }).finally(() => { this.cargar = false; });
        } else {
          // Agregar nuevo paquete
          this.$http.post('paquetes.add', formData).then(response => {
            this.initialize();
            this.cargar = false;
            this.close();
          }).catch(error => {
            this.validarError(error);
          }).finally(() => { this.cargar = false; });
        }
      },

      // Agregar un artículo al paquete
      agregarArticuloAlPaquete() {
        if (!this.selectedArticulo || this.cantidadArticulo <= 0 || !this.paqueteActual) {
          return;
        }

        this.cargar = true;
        const detalleData = {
          idpaquetes: this.paqueteActual.idpaquetes,
          idarticulos: this.selectedArticulo.idarticulos,
          cantidad: this.cantidadArticulo
        };

        this.$http.post('paquetes.detalle.add', detalleData).then(response => {
          // Recargar los detalles del paquete
          this.$http.get(`paquetes.detalle/${this.paqueteActual.idpaquetes}`).then(response => {
            this.detallesPaquete = response.data.detalles || [];
            this.closeDialogAgregarArticulo();
            this.cargar = false;
            // Actualizar el paquete actual con el nuevo precio si se actualizó
            if (response.data.paquete) {
              this.paqueteActual = response.data.paquete;
            }
          });
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Editar detalle (cantidad de un artículo)
      editDetalle(item) {
        this.editedDetalle = Object.assign({}, item);
        this.dialogEditarDetalle = true;
      },

      // Cerrar diálogo de editar detalle
      closeEditarDetalle() {
        this.dialogEditarDetalle = false;
        this.editedDetalle = {
          idpaquetes_detalles: 0,
          idpaquetes: 0,
          idarticulos: 0,
          cantidad: 1,
          articulo: '',
          precio_articulo: 0,
          foto_articulo: ''
        };
      },

      // Guardar cambios en detalle
      guardarCambiosDetalle() {
        if (this.editedDetalle.cantidad <= 0) {
          this.validarError({ message: 'La cantidad debe ser mayor a 0' });
          return;
        }

        this.cargar = true;
        const detalleData = {
          idpaquetes: this.editedDetalle.idpaquetes,
          idarticulos: this.editedDetalle.idarticulos,
          cantidad: this.editedDetalle.cantidad,
          deleted: 0
        };

        this.$http.put(`paquetes.detalle.update/${this.editedDetalle.idpaquetes_detalles}`, detalleData).then(response => {
          // Recargar los detalles del paquete
          this.$http.get(`paquetes.detalle/${this.paqueteActual.idpaquetes}`).then(response => {
            this.detallesPaquete = response.data.detalles || [];
            this.closeEditarDetalle();
            this.cargar = false;
            // Actualizar el paquete actual con el nuevo precio si se actualizó
            if (response.data.paquete) {
              this.paqueteActual = response.data.paquete;
            }
          });
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Eliminar un detalle (artículo) del paquete
      deleteDetalle(item) {
        this.selectedDetalleToDelete = item;
        this.dialogDeleteDetalle = true;
      },

      // Cerrar diálogo de eliminar detalle
      closeDeleteDetalle() {
        this.dialogDeleteDetalle = false;
        this.selectedDetalleToDelete = null;
      },

      // Confirmar eliminación de detalle
      deleteDetalleConfirm() {
        if (!this.selectedDetalleToDelete) {
          return;
        }

        this.cargar = true;
        this.$http.put(`paquetes.detalle.delete/${this.selectedDetalleToDelete.idpaquetes_detalles}`, {
          idpaquetes: this.selectedDetalleToDelete.idpaquetes
        }).then(response => {
          // Recargar los detalles del paquete
          this.$http.get(`paquetes.detalle/${this.paqueteActual.idpaquetes}`).then(response => {
            this.detallesPaquete = response.data.detalles || [];
            this.closeDeleteDetalle();
            this.cargar = false;
            // Actualizar el paquete actual con el nuevo precio si se actualizó
            if (response.data.paquete) {
              this.paqueteActual = response.data.paquete;
            }
          });
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Calcular el total del paquete
      calcularTotalPaquete() {
        if (!this.detallesPaquete.length) {
          return 0;
        }
        
        return this.detallesPaquete.reduce((total, item) => {
          return total + (item.precio_articulo * item.cantidad);
        }, 0);
      },

      // Actualizar el precio del paquete basado en los artículos
      actualizarPrecioPaquete() {
        const nuevoPrecio = this.calcularTotalPaquete();
        if (nuevoPrecio === 0) {
          return;
        }

        this.cargar = true;
        const paqueteData = {
          nombre: this.paqueteActual.nombre,
          precio: nuevoPrecio,
          notas: this.paqueteActual.notas,
          deleted: 0,
          foto: this.paqueteActual.foto
        };

        this.$http.put(`paquetes.update/${this.paqueteActual.idpaquetes}`, paqueteData).then(response => {
          this.validarSuccess('Precio del paquete actualizado correctamente');
          this.paqueteActual.precio = nuevoPrecio;
          // Actualizar el paquete en la lista principal
          const index = this.paquetes.findIndex(p => p.idpaquetes === this.paqueteActual.idpaquetes);
          if (index !== -1) {
            this.paquetes[index].precio = nuevoPrecio;
          }
        }).catch(error => {
          this.validarError(error);
        }).finally(() => { this.cargar = false; });
      },

      // Gestión de archivos e imágenes
      cargarFotos() {
        if (!this.files) {
          return;
        }
        // Creamos una variable tipo FormData
        let formData = new FormData();
        // Se crea el objeto y se le agrega como un apendice el archivo
        formData.append('file', this.files);
        // Mandamos a convertir la imagen a base64
        this.getBase64(this.files, formData);
      },
      
      getBase64(file, formData) {
        var me = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          me.vistaPrevias.push({
            url: reader.result,
            formData: formData,
            image_name: file.name,
            file
          });
        };
      },
      
      eliminarFoto(value) {
        this.vistaPrevias.forEach((element, index) => {
          if (element.url == value) {
            this.vistaPrevias.splice(index, 1);
          }
        });
      }
    },
  };
</script>